import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";

// The vendor list is paginated (10 a page by default, 50 at most), and every
// caller needs all of it: a vendor page finds its vendor by slug in this list, so
// a vendor past the first page showed "Vendor details are currently unavailable".
// Fetches every page and returns the first page's body with all rows in `data`.
const VENDOR_PAGE_SIZE = 50;

export const getVendors = async () => {
  const first = await axiosInstance.get(API_ENDPOINTS.VENDORS, {
    params: { page: 1, limit: VENDOR_PAGE_SIZE },
  });
  const totalPages = Number(first?.pagination?.totalPages) || 1;
  if (totalPages <= 1 || !Array.isArray(first?.data)) return first;

  const rest = await Promise.all(
    Array.from({ length: totalPages - 1 }, (_, i) =>
      axiosInstance.get(API_ENDPOINTS.VENDORS, {
        params: { page: i + 2, limit: VENDOR_PAGE_SIZE },
      })
    )
  );
  const rows = first.data.concat(...rest.map((body) => (Array.isArray(body?.data) ? body.data : [])));
  return {
    ...first,
    data: rows,
    pagination: { ...first.pagination, page: 1, limit: rows.length, totalPages: 1 },
  };
};

export const getVendorById = async (id) => {
  try {
    return await axiosInstance.get(API_ENDPOINTS.GET_VENDOR_BY_ID(id));
  } catch (error) {
    throw error;
  }
};

export const getVendorShareDetails = async (id) => {
  try {
    return await axiosInstance.get(API_ENDPOINTS.GET_VENDOR_SHARE_DETAILS(id));
  } catch (error) {
    throw error;
  }
};

export default {
  getVendors,
  getVendorById,
  getVendorShareDetails,
};
